import TagsSelect from './TagsSelect';
export default TagsSelect;
//# sourceMappingURL=index.js.map
